export default __webpack_public_path__ + "static/media/product1.e19382a8.png";